import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en.json'
import es from './es.json'
import fr from './fr.json'
import de from './de.json'
import nl from './nl.json'
import pt from './pt.json'
import it from './it.json'
import ja from './ja.json'

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en.en },
    es: { translation: es.es },
    fr: { translation: fr.fr },
    de: { translation: de.de },
    nl: { translation: nl.nl },
    pt: { translation: pt.pt },
    it: { translation: it.it },
    ja: { translation: ja.ja },
  },
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ['querystring', 'cookie', 'localStorage', 'navigator'],
    caches: ['localStorage', 'cookie'],
  },
})

export default i18n
